import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/fontawesome";
import "./plugins/bootstrap-vue";
import App from "./App.vue";

//MODULES
import VueAWN from "vue-awesome-notifications";
let options = {
  position: "bottom-right",
  labels: {
    info: "Information",
    success: "Succès",
    warning: "Attention",
    alert: "Erreur",
    async: "Chargement...",
    confirm: "Attention",
    confirmOk: "Valider",
    confirmCancel: "Annuler",
  },
};
Vue.use(VueAWN, options);
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import router from "./router";
import store from "./store";
import axios from "axios";
import VueLayers from "vuelayers";

import "vuelayers/lib/style.css"; // needs css-loader
import "./plugins/axios";
import "./config.js";

Vue.use(VueLayers);
Vue.config.productionTip = false;
import VueCrypt from 'vue-crypt'
Vue.use(VueCrypt)

// Primevue
import PrimeVue from 'primevue/config';

import DataTable from 'primevue/datatable';
Vue.component('DataTable', DataTable);

import Column from 'primevue/column';
Vue.component('Column', Column);

import InputText from 'primevue/inputtext';
Vue.component('InputText', InputText);

import InputNumber from 'primevue/inputnumber';
Vue.component('InputNumber', InputNumber);

import Dropdown from 'primevue/dropdown';
Vue.component('Dropdown', Dropdown);

import Multiselect from 'primevue/multiselect';
Vue.component('Multiselect', Multiselect);

import Calendar from 'primevue/calendar';
Vue.component('Calendar', Calendar);

import Button from 'primevue/button';
Vue.component('Button', Button);

import TriStateCheckbox from 'primevue/tristatecheckbox';
Vue.component('TriStateCheckbox', TriStateCheckbox);

import Tooltip from 'primevue/tooltip';
Vue.directive('tooltip', Tooltip);

Vue.use(PrimeVue, {
  locale: {
    startsWith: 'Comence par',
    contains: 'Contient',
    notContains: 'Ne contient pas',
    endsWith: 'Se termine par',
    equals: 'Equivaut à',
    notEquals: 'Est différent de',
    noFilter: 'Ne pas filtrer',
    lt: 'Inférieur à',
    lte: 'Inférieur ou égal à',
    gt: 'Supérieur à',
    gte: 'Supérieur ou égal à',
    dateIs: 'La date est',
    dateIsNot: 'La date n\'est pas',
    dateBefore: 'Date antérieure à',
    dateAfter: 'Date postérieure à',
    clear: 'Réinitialiser',
    apply: 'Appliquer',
    matchAll: 'Tout faire correspondre',
    matchAny: 'Faire correspondre certaines valeurs',
    addRule: 'Ajouter une règle',
    removeRule: 'Enlever une règle',
    accept: 'Oui',
    reject: 'Non',
    choose: 'Choisir',
    upload: 'Envoyer',
    cancel: 'Annuler',
    dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
    dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    dayNamesMin: ["Di","Lu","Ma","Me","Je","Ve","Sa"],
    monthNames: ["Janvier","Fevrier","Mars","Avril","Mai","Juin","Juillet","Aout","Septembre","Octobre","Novembre","Decembre"],
    monthNamesShort: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun","Jul", "Aou", "Sep", "Oct", "Nov", "Dec"],
    today: 'Ajourd\'hui',
    weekHeader: 'Sem',
    firstDayOfWeek: 0,
    dateFormat: 'dd/mm/yy',
    weak: 'Faible',
    medium: 'Moyen(ne)',
    strong: 'Fort(e)',
    passwordPrompt: 'Saisir un mot de passe',
    emptyFilterMessage: 'Aucun résultat',
    emptyMessage: 'Aucune option disponible'
  },
});

import {
  ValidationObserver,
  ValidationProvider,
  extend
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import {
  localize
} from "vee-validate";
import fr from "vee-validate/dist/locale/fr.json";
localize("fr", fr);
// install rules
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// COMPONENTS GLOBAL
import Autocomplete from "vuejs-auto-complete";
Vue.component("autocomplete", Autocomplete);

// import component and stylesheet
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";
const datepickerOptions = {
  days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
  daysShort: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
  monthNames: [
    'Janvier',
    'Fevrier',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],
  colors: {
    selected: '#00a699',
    inRange: '#66e2da',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#33dacd',
    disabled: '#fff',
    hoveredInRange: '#67f6ee'
  },
  texts: {
    apply: 'Appliquer',
    cancel: 'Annuler',
    keyboardShortcuts: 'Raccourcis',
  },
  // ariaLabels: {
  //   // chooseDate: (date) => date,
  //   // chooseStartDate: (date) => `Choisir ${date} comme date de début.`,
  //   // chooseEndDate: (date) => `Choisir ${date} comme date de fin.`,
  //   // selectedDate: (date) => `Selection du ${date}`,
  //   unavailableDate: 'Date non disponible',
  //   previousMonth: 'Aller au mois précedent',
  //   nextMonth: 'Aller au mois suivant',
  //   closeDatepicker: 'Fermer le calendrier',
  //   openKeyboardShortcutsMenu: 'Ouvrir le menu des raccourcis',
  //   closeKeyboardShortcutsMenu: 'Fermer le menu des raccourcis'
  // },
  keyboardShortcuts: [{
      symbol: '↵',
      label: 'Sélectionnez la date en surbrillance',
      symbolDescription: 'Touche entrée'
    },
    {
      symbol: '←/→',
      label: 'Déplacement d\' un jour à gauche ou à droite',
      symbolDescription: 'Touche directionnel gauche ou droite'
    },
    {
      symbol: '↑/↓',
      label: 'Déplacemene d\'une semaine en haut ou en bas',
      symbolDescription: 'touche directionnel haut ou bas'
    },
    {
      symbol: 'PgUp/PgDn',
      label: 'Changer les mois',
      symbolDescription: 'touche page suivante, précédente'
    },
    {
      symbol: 'Home/End',
      label: 'Aller au dernier jour d\'une semaine',
      symbolDescription: 'touche Fin'
    },
    {
      symbol: 'Esc',
      label: 'Fermer le panneau',
      symbolDescription: 'Touche échap'
    },
    {
      symbol: '?',
      label: 'Ouvrir le panneau',
      symbolDescription: 'Raccourcis'
    }
  ],
};
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

const DEFAULT_TITLE = "SUDTHD";
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const roles = to.meta.roles;

  // //pas connecte on redirige
  if (requiresAuth && !store.getters["Authentification/isAuthenticated"]) {
    next("/login");
  }

  //controle sur l'utilisateur connected
  else if (
    store.getters["Authentification/isAuthenticated"] &&
    !store.getters["Authentification/isUserConnected"]
  ) {
    Vue.axios.get(window.urlapi + "userConnected").then((response) => {
      if (typeof response.data.data.id !== "undefined") {
        store.dispatch("Authentification/setUserConnected", response.data.data);
        next();
      } else {
        next();
      }
    });
  }

  //gestion des rôles
  if (roles) {
    var roleOk = false;
    if (roles.indexOf("All") != -1) {
      roleOk = true;
    }

    let userConnected = store.getters["Authentification/userConnected"];
    if (userConnected.roles) {
      for (var i = 0; i < userConnected.roles.length; i++) {
        if (roles.indexOf(userConnected.roles[i]) != -1) {
          roleOk = true;
        }
      }
    }

    if (!roleOk) {
      // next('/erreur')
    }
  }

  next();
});
window.Event = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");